// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"dt","backToTop":"dt"};